import React, { useState, useEffect } from "react";
import "./Packages.css";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import api from "../../Api.js";

export default function Packages() {
  const [activeTab, setActiveTab] = useState("Wedding");

  const [PackagesData, setPackagesData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await api.get("banquet-events");
        setPackagesData(response?.data?.data || []);
        console.log("Fetched packages:", response.data.data);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };
    fetchPackages();
  }, []);
  const PackageFilteredData = PackagesData.filter((pkg) => pkg.event_name === activeTab);
  console.log("Filtered packages for active tab:", PackageFilteredData);

  return (
    <section className="package-section">
      <div className="container">

        <h2 className="main-title">
          Our <span>Package</span>
        </h2>

        {/* Tabs */}
        <div className="package-tabs">
          {["Wedding", "Birth Day", "Private"].map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Pricing Cards */}
        <div className="package-cards">

          {/* Standard */}
          {PackageFilteredData.map((pkg, index) => (
            <div className={`card ${pkg?.event_type === "Gold" ? "premium" : ""}`} key={pkg.id || index}>
             {pkg?.event_type === "Gold" && <div className="badge">Most Popular</div>}
              <h3>{pkg.event_type}</h3>
              <h2 className="price">₹{pkg.price}/- <span>+ GST</span></h2>
              <ul>
              <li>✔ <strong>Location:</strong> {pkg.location || "Not specified"}</li>
              <li>✔ <strong>Plot Size:</strong>{" "}
                  {pkg.plot_size ? `${pkg.plot_size} sq.ft` : "N/A"}</li>

            </ul>
              <div
                className="wpkg-feature-list"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(pkg.event_feature || ""),
                }}
              ></div>
              <button className="outline-btn"  onClick={()=>navigate(`/packages/${pkg?.id}`)}>Enquire Now</button>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}